import RestService from './RestService';

export default class KeyBehaviors extends RestService {
    constructor(parentService, parentId) {
        if (parentService) {
            super(`${parentService.baseUrl}/${parentId}/keyBehaviors`);
        } else throw new Error('Can be only nested service');
    }
}
